import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CustomLayoutDrawerContent } from 'components/atoms/drawer';
import { PageLoading } from 'components/atoms/loading';

const DrawerContent = styled(CustomLayoutDrawerContent)`
  ${CustomLayoutDrawerContent.Content} {
    padding: 0 !important;
  }
  ${CustomLayoutDrawerContent.Footer} {
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-05);
  }
`;

export const AIDrawerContentLoading = () => {
  return (
    <>
      <DrawerContent>
        <CustomLayoutDrawerContent.Title>
          <CustomLayoutDrawerContent.Title.Description>
            <FormattedMessage id="ai_fill.meetings.select.drawer.description" />
          </CustomLayoutDrawerContent.Title.Description>
          <FormattedMessage id="ai_fill.meetings.select.drawer.not_connected.title" />
        </CustomLayoutDrawerContent.Title>
        <CustomLayoutDrawerContent.Content>
          <PageLoading />
        </CustomLayoutDrawerContent.Content>
      </DrawerContent>
    </>
  );
};
